import app from './app';
import user from './user'

export default {
  app,
  user,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js